import React, { useState } from 'react';
import { Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { ApiUrl, Headers } from '../services/ApiUrl';
import { useUserAdminPresencial } from '../stores/UserAdminPresencial';
import { Navigate } from 'react-router-dom'

const LoginForm = () => {
  const [emailUser, setEmailUser] = useState('');
  const [passwordUser, setPasswordUser] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const userAdminPresencial = useUserAdminPresencial((state) => state.userAdminPresencial)
  const updateUserAdminPresencial = useUserAdminPresencial((state) => state.updateUserAdminPresencial)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const data = { email_user: emailUser, password_user: passwordUser };
    const url = `${ApiUrl}users?login=true&suffix=user`;

    try {
      const response = await axios.post(url, data, { headers: Headers });
      let newUser = []
      if (response.status === 200) {
        //console.log(response.data);
        newUser = {
          error: false,
          login:true,
          id_user:response.data.results[0].id_user,
          tipo_user: response.data.results[0].tipo_user,
          name_user: response.data.results[0].name_user,
          errorMsg: ""               
        }
        updateUserAdminPresencial(newUser)     
        // redirigir a propuestas      
      } else {
        setError('Credenciales inválidas. Por favor, intente de nuevo.');
      }
    } catch (err) {
      setError('Hubo un error al intentar iniciar sesión. Por favor, intente más tarde.');
      //console.error('Error de login:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    {!userAdminPresencial.login &&
    <Container style={{marginTop:'50px'}}>
      <Row>
        <Col>
          <p>
            Formulario de login para votos presenciales
          </p>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control 
                type="email" 
                placeholder="Ingrese su email" 
                value={emailUser}
                onChange={(e) => setEmailUser(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control 
                type="password" 
                placeholder="Contraseña" 
                value={passwordUser}
                onChange={(e) => setPasswordUser(e.target.value)}
                required
              />
            </Form.Group>

            {error && <Alert variant="danger">{error}</Alert>}

            <Button variant="primary" type="submit" disabled={isLoading}>
              {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
      }
      {userAdminPresencial.login &&
              
              <Navigate to="/propuestas" />
 
      }
    </>
  );
};

export default LoginForm;